export default class XEndpoints {
    // Auth
    static login = '/company/auth/login';
    static refreshToken = '/company/auth/refresh-token';
    static updateProfile = '/company/auth/update-profile';
    static allModules = '/company/auth/all-modules';

    // User
    static role = '/company/user/role';
    static user = '/company/user';

    // Setting
    static preferences = '/company/setting/preferences';
    static rateType = '/company/setting/rate-type';
    static taxType = '/company/setting/tax-type';
    static color = '/company/setting/color';
    static expenseCategory = '/company/setting/expense-category';

    // Customer
    static customer = '/company/customer';

    // Inventory
    static unit = '/company/product/unit';
    static category = '/company/product/category';
    static product = '/company/product/product';
    static attribute = '/company/attribute'
    static variant = '/company/variant';
    static inventory = '/company/inventory';

    // Purchase
    static purchase = '/company/purchase';
    static purchaseReturn = '/company/purchase/return';

    // Sale
    static sale = '/company/sale';
    static creditNote = '/company/sale/credit-note';

    // Quotation
    static quotation = '/company/quotation';
    static deliveryChallan = '/company/quotation/delivery-challan';

    // Accounts
    static expense = '/company/account/expense';
    static voucher = '/company/account/voucher';

    // Upload
    static upload = '/upload';

}
